/**
 * StepperComponent is a component used convey progress through numbered steps. It provides a wizard-like workflow
 *
 * @example
 *
 *  import Stepper from '../common/Stepper.jsx';
 *
 *  MyComponent = () => {
 *    const steps = [
 *      { label: 'Step A' },
 *      { label: 'Step B' },
 *      { label: 'Step C' }
 *    ];
 *
 *    return (
 *      <Stepper steps={steps} handleNextCallback={handleNextCallback}>
 *        <ComponentStep1 data={} />
 *        <ComponentStep2 data={} />
 *        <ComponentStep3 data={} />
 *      </Stepper>
 *     )
 *  }
 */

import React, { useState, lazy, Suspense } from 'react';
const StepperComponent = lazy(() => import('./Stepper/StepperComponent.jsx'));


export default function Stepper(props){
  return <Suspense fallback={<div></div>}>
    <StepperComponent {...props} />
  </Suspense>
}
